import { gql } from '@apollo/client'

export const GET_ME = gql`
  query getMe {
    me {
      ... on User {
        permissions
        releaseType
        lastActivity
        area
        createdAt
        isFirstLogin
        firstLogin
        workspaces {
          id
          workspaceBrandV2 {
            id
            name
            thumbnail
          }
          workspaceSettings {
            allowedModules
          }
        }

        company {
          id
          name
          country
          contractBegin
          contractEnd
          allowedEmailDomains
          thumbnail

          hubspotCompanyStage
          hubspotHealthScoreStatus
          hubspotHealthScoreValue
          hubspotLifecycleStage

          companyType {
            id
            name
          }

          contract {
            maxJobs
            maxReports
          }

          usersCount {
            admins
            editors
            viewers
            billable
          }

          # plan has the default values
          plan {
            name
            hasWinninReports
            savedPostSearches
            jobs
            editors
            viewers
            workspaces
            languages
            isActive
            workspaceChannels
            providers
            jobPinnedCreators
            jobPinnedPosts
            jobPinnedSubtopics
            jobPinnedTopics
            jobPinnedSavedSearches
            jobFolders
            jobPins
            workspaceZaiReports
            workspaceBrandCompetitors
          }

          # companyPlan has the addon values
          companyPlan {
            id: planId
            companyId
            hasWinninReports
            savedPostSearches
            jobs
            editors
            viewers
            languages
            workspaces
            isActive
            endDate
            startDate
            workspaceChannels
            providers
            jobPinnedCreators
            jobPinnedPosts
            jobPinnedSubtopics
            jobPinnedTopics
            jobPinnedSavedSearches
            jobFolders
            jobPins
            workspaceZaiReports
            workspaceBrandCompetitors
          }
        }

        brands {
          name
          thumbnail
          id
          companyId
          status

          panels {
            id
            brandId
            title
            youtubeChannelThumbnail
            youtubeChannelId
            youtubeChannelName
            youtubeRefreshTokenStatus
            audienceRecommendationStatus
          }

          category {
            id
            country
            name
          }
        }

        email
        id
        onboardingV2
        jobTitleOther
        jobLevelId
        jobLevel
        jobLevelOther
        userPreference {
          id
          zaiPreference
          createdAt
          updatedAt
        }
        name
        onboarding
        phone
        role
        thumbnail
        firstName
        lastName
        country
        jobTitle

        jobTitleType {
          id
          name
        }

        status
        facebookId

        terms {
          acceptedLastTerms
          lastAcceptedVersion
          lastAcceptTimestamp
        }

        attributes {
          hubspot {
            key
            value
          }
        }
      }

      ... on StatusMessage {
        success
        code
        title
        message
      }
    }
  }
`
